"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse20023ToJSON = exports.InlineResponse20023FromJSONTyped = exports.InlineResponse20023FromJSON = void 0;
var runtime_1 = require("../runtime");
function InlineResponse20023FromJSON(json) {
    return InlineResponse20023FromJSONTyped(json, false);
}
exports.InlineResponse20023FromJSON = InlineResponse20023FromJSON;
function InlineResponse20023FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nextAction': !(0, runtime_1.exists)(json, 'nextAction') ? undefined : json['nextAction'],
    };
}
exports.InlineResponse20023FromJSONTyped = InlineResponse20023FromJSONTyped;
function InlineResponse20023ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nextAction': value.nextAction,
    };
}
exports.InlineResponse20023ToJSON = InlineResponse20023ToJSON;
